// extracted by mini-css-extract-plugin
export default {"container":"_2LCgy","isTop":"XfpNZ","withPagination":"_2veMZ","innerContainer":"_2U3xe","pagination":"_2P5Eo","arrow":"_1IKp8","page":"_3pklO","active":"_1X-t7"};